import client from './client';
import { Apartment, Beacon, PaginatedResponse } from '../types';

export interface ApartmentListParams {
  page?: number;
  limit?: number;
  include_inactive?: boolean;
  name?: string;
  address?: string;
}

export const getList = async (params: ApartmentListParams = {}): Promise<PaginatedResponse<Apartment>> => {
  const res = await client.get('/api/v1/apartments', { params });
  return res.data;
};

export const create = async (data: Partial<Apartment>): Promise<Apartment> => {
  const res = await client.post('/api/v1/apartments', data);
  return res.data;
};

export const update = async (id: string, data: Partial<Apartment>): Promise<Apartment> => {
  const res = await client.put(`/api/v1/apartments/${id}`, data);
  return res.data;
};

export const remove = async (id: string): Promise<Apartment> => {
  const res = await client.delete(`/api/v1/apartments/${id}`);
  return res.data;
};

export const removePermanent = async (id: string): Promise<{ message: string; deleted_events: number }> => {
  const res = await client.delete(`/api/v1/apartments/${id}/permanent`);
  return res.data;
};

// Beacon API

export const getBeacons = async (apartmentId: string): Promise<Beacon[]> => {
  const { data } = await client.get<Beacon[]>(`/api/v1/apartments/${apartmentId}/beacons`);
  return data;
};

export const addBeacon = async (apartmentId: string, body: { beacon_hw_id: number; type: string; name?: string }) => {
  const { data } = await client.post<Beacon>(`/api/v1/apartments/${apartmentId}/beacons`, body);
  return data;
};

export const updateBeacon = async (beaconId: string, body: { beacon_hw_id?: number; type?: string; name?: string }) => {
  const { data } = await client.put<Beacon>(`/api/v1/beacons/${beaconId}`, body);
  return data;
};

export const removeBeacon = async (beaconId: string): Promise<{ message: string; warning?: string }> => {
  const { data } = await client.delete<{ message: string; warning?: string }>(`/api/v1/beacons/${beaconId}`);
  return data;
};

export const updateBeaconBattery = async (beaconId: string, batteryLow: boolean) => {
  const { data } = await client.patch(`/api/v1/beacons/${beaconId}/battery`, { battery_low: batteryLow });
  return data;
};
